import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Homepage section paddings — kind controls vertical rhythm.
 *  - default: standard section (categories, promos, product sliders)
 *  - banner:  edge-to-edge on desktop
 */
export const homepageSectionVariants = cva('', {
  variants: {
    kind: {
      default: 'p-3 md:px-0 md:py-6',
      banner:  'p-3 md:p-0',
    },
  },
  defaultVariants: { kind: 'default' },
})
export type HomepageSectionVariants = VariantProps<typeof homepageSectionVariants>
